import LpForm from '../../plugins/lpForm.js';

// LP-Form設定 =============================

// テストページにアップする場合はconfirmURL, finishURL, confirmURLを変える必要がある
// 例 : confirmURL: "/wifi-erasutamo/contact/confirm/"
// テストURL : http://testaccount.main.jp/wifi-erasutamo/

//お問い合わせフォーム
//お問い合わせフォームはデフォルト設定です。
new LpForm('#contant-form', {
  storageName: "form-session-storage", //セッションストレージ名
  confirmURL: "/cloud-manage/contact/confirm/", //確認画面のURL
  finishURL: "/cloud-manage/contact/finish/", //完了画面画面のURL
  sendAPI: "/cloud-manage/api/contacts/send", //メール送信用のAPI_URL
}) 

//電話予約フォーム
new LpForm('#tel-contant-form', {
  storageName: "form-tel", //セッションストレージ名
  confirmURL: "/telform/confirm/", //確認画面のURL
  finishURL: "/telform/finish/", //完了画面画面のURL
  sendAPI: "/api/telform/send", //メール送信用のAPI_URL
}) 

// ============================= LP-Form設定ここまで
